/**
 * Human copy for raw activity_log action keys (T25). The canonical action
 * vocabulary lives in shared/activity.ts; this maps each key to a generic
 * verb phrase for surfaces that show cross-task notifications (inbox page,
 * notifications drawer). TaskActivityFeed keeps its own "this task"
 * phrasings — different grammatical context.
 */

const ACTIVITY_VERB: Record<string, string> = {
  "task.created": "created a task",
  "task.updated": "edited a task",
  "task.moved": "moved a task",
  "task.deleted": "deleted a task",
  "comment.added": "commented on a task",
  "project.created": "created a project",
  "project.updated": "updated a project",
};

export function activityVerb(action: string): string {
  // Unknown keys (vocabulary added server-side first) degrade to readable
  // words rather than rendering "task.moved" verbatim.
  return ACTIVITY_VERB[action] ?? action.replace(/[._]/g, " ");
}
